import {useState} from "react";
import {createNotification} from "app/actions/notifications";
import {create as createUser} from "app/requests/user";
import Field from "components/helpers/form/field";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";

export default function Form({surveyID}) {
  const {dispatch} = useAppContext();
  const [changes, setChanges] = useState({});
  const onChange = ({target}) => {
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    createUser({
      survey_id: surveyID,
      user: changes
    }).then(({errors, location, message, success}) => {
      if(success) { return window.location.assign(location); }

      dispatch(createNotification({content: errors || message, type: "error"}));
    });
  };
  const value = (name) => valueFrom({name, objects: [changes]});

  return (
    <section className="container max-w-screen-sm">
      <form onSubmit={onSubmit}>
        <h1 className="text-center">Before You Begin</h1>
        <div className="my-2 text-center">You're just minutes away from discovering your personality. Sign up below, answer "me" or "not me" to each image and get your results!</div>
        <Field
          label="Email"
          name="email"
          namespace="user"
          onChange={onChange}
          placeholder="you@example.com"
          required={true}
          type="email"
          value={value("email")}
        />
        <div className="text-center">
          <button className="btn btn-blue" type="submit">Continue</button>
        </div>
      </form>
    </section>
  );
}
